import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { userService } from "../../_services/user.service";

const AddressData = {
    Country: ["United States"],
    State: [
        "Please select state", "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ]
};

const validationSchema = Yup.object({
    Fname: Yup.string().required("First Name is required"),
    Lname: Yup.string().required("Last Name is required"),
    Address1: Yup.string().required("Address is required"),
    Address2: Yup.string(),
    State: Yup.string().required("State is required"),
    City: Yup.string().required("City is required"),
    Zip: Yup.string().matches(/^\d{5}$/, "Enter a valid 5-digit Zip Code").required("Zip Code is required"),
    Email: Yup.string().email("Enter a valid Email").required("Email is required"),
    PhoneNo: Yup.string()
        .matches(/^\+?(\d{1,3})?[-.\s]?(\(\d{1,4}\)|\d{1,4})[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/, "Enter a valid Phone Number")
        .required("Phone is required"),
    GroupNumber: Yup.string().required("Group Number is required"),
});

const AddressForm = ({ onSubmit }) => {
    const [addressDetails, setAddressDetails] = useState({
        Fname: "",
        Lname: "",
        Address1: "",
        Address2: "",
        State: "",
        City: "",
        Zip: "",
        Email: "",
        PhoneNo: "",
        GroupNumber: "",
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [groupNumbers, setGroupNumbers] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            setError("");
            setSuccess("");
            try {
                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                const userData = await userService.GetUserAccountInfo(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
                if (userData && userData.length) {
                    const gnData = await fetchGroupNumbers()
                    setAddressDetails({
                        Fname: userData[0].fname || "",
                        Lname: userData[0].lname || "",
                        Address1: userData[0].address1 || "",
                        Address2: userData[0].address2 || "",
                        State: userData[0].stateName || "",
                        City: userData[0].cityName || "",
                        Zip: userData[0].zipCode || "",
                        Email: userData[0].email || "",
                        PhoneNo: userData[0].phone || "",
                        GroupNumber: (gnData.find(groupno => groupno.isPrimary)).groupnumber || ''
                    });
                    //setSuccess("User data loaded successfully!");
                }
            } catch (error) {
                setError("Failed to fetch user data. Please try again.");
                //console.error("Error fetching user account info:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const fetchGroupNumbers = async () => {
        setError("");
        setSuccess("");
        try {
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const groupNoData = await userService.GetUserGroups(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            if (groupNoData && groupNoData.length) {
                setGroupNumbers(groupNoData);
                return groupNoData
            }
        } catch (error) {
            setError("Failed to fetch user data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const formik = useFormik({
        initialValues: addressDetails,
        enableReinitialize: true,
        validationSchema,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values) => {
            onSubmit(values);
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} className="space-y-4">
            {loading && <div className="page-loader"></div>}
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            {!loading && <>

                <div className="input-wrapper select-wrapper">
                    <select name="GroupNumber" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.GroupNumber} onFocus={() => formik.setFieldError("GroupNumber", "")} className="input">
                        <option value="">Select Group Number</option>
                        {groupNumbers && groupNumbers.length ? groupNumbers.map((item, index) => <option value={item.groupnumber} key={index}>{item.groupnumber}</option>) : null}
                    </select>
                    <label>Group Number</label>
                    {formik.touched.GroupNumber && formik.errors.GroupNumber ? <div className="error">{formik.errors.GroupNumber}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="Fname" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.Fname} onFocus={() => formik.setFieldError("Fname", "")} className="input" placeholder=" " />
                    <label>First Name</label>
                    {formik.touched.Fname && formik.errors.Fname ? <div className="error">{formik.errors.Fname}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="Lname" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("Lname", "")} value={formik.values.Lname} className="input" placeholder=" " />
                    <label>Last Name</label>
                    {formik.touched.Lname && formik.errors.Lname ? <div className="error">{formik.errors.Lname}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="Address1" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("Address1", "")} value={formik.values.Address1} className="input" placeholder=" " />
                    <label>Address Line 1</label>
                    {formik.touched.Address1 && formik.errors.Address1 ? <div className="error">{formik.errors.Address1}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="Address2" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("Address2", "")} value={formik.values.Address2} className="input" placeholder=" " />
                    <label>Address Line 2 (Optional)</label>
                </div>

                <div className="input-wrapper select-wrapper">
                    <select name="State" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.State} onFocus={() => formik.setFieldError("State", "")} className="input" placeholder=" ">
                        {AddressData.State.map((state, index) => (
                            <option key={index} value={state}>{state}</option>
                        ))}
                    </select>
                    <label>State</label>
                    {formik.touched.State && formik.errors.State ? <div className="error">{formik.errors.State}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="City" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("City", "")} value={formik.values.City} className="input" placeholder=" " />
                    <label>City</label>
                    {formik.touched.City && formik.errors.City ? <div className="error">{formik.errors.City}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="Zip" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("Zip", "")} value={formik.values.Zip} className="input" placeholder=" " />
                    <label>Zip Code</label>
                    {formik.touched.Zip && formik.errors.Zip ? <div className="error">{formik.errors.Zip}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="email" name="Email" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("Email", "")} value={formik.values.Email} className="input" placeholder=" " />
                    <label>Email</label>
                    {formik.touched.Email && formik.errors.Email ? <div className="error">{formik.errors.Email}</div> : null}
                </div>

                <div className="input-wrapper">
                    <input type="text" name="PhoneNo" onChange={formik.handleChange} onBlur={formik.handleBlur} onFocus={() => formik.setFieldError("PhoneNo", "")} value={formik.values.PhoneNo} className="input" placeholder=" " />
                    <label>Phone Number</label>
                    {formik.touched.PhoneNo && formik.errors.PhoneNo ? <div className="error">{formik.errors.PhoneNo}</div> : null}
                </div>

                <button type="submit" className="btn-primary">Checkout</button>
            </>}
        </form>
    );
};

export default AddressForm;
